var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.963 13.083 5.416-5.082a2.834 2.834 0 0 0 .187-3.94 2.662 2.662 0 0 0-3.819-.182L4.392 13.59a3.077 3.077 0 0 0 0 4.488l10.356 9.717a2.662 2.662 0 0 0 3.818-.182 2.832 2.832 0 0 0-.189-3.938l-5.36-5.023h15.734c2.932.214 5.556 1.954 6.965 4.616a9.163 9.163 0 0 1 0 8.545c-1.409 2.663-4.033 4.402-6.965 4.617H27.38a2.785 2.785 0 1 0 0 5.569h1.371c4.82-.276 9.162-3.09 11.497-7.451a14.891 14.891 0 0 0 0-14.014c-2.335-4.36-6.678-7.175-11.497-7.451H12.963z",
    fill: "#282828",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoBlack);
export default __webpack_public_path__ + "static/media/undo-black.dca0a96d19f00fb990f343fc8a1fb450.svg";
export { ForwardRef as ReactComponent };